export default {
    cn: {
        ibPrimary: {
            back: '返回',
            commissionSetting: '佣金设定',
            templateSetting: '模板管理',
            ibResult: {
                title: '代理结果',
                list: [
                    { text: '实时佣金结果', link: '/ib/realTimeResult' },
                    { text: '月结佣金结果', link: '/ib/monthlyIBResult' },
                    { text: 'CPA佣金结果', link: '/ib/CPACommissionResult' }
                ]
            },
            ibResult_v2: {
                title: '代理结果',
                list: [
                    { text: '实时佣金结果', link: '/ib_v2/realTimeResult' },
                    { text: '月结佣金结果', link: '/ib_v2/monthlyIBResult' },
                    { text: 'CPA佣金结果', link: '/ib_v2/CPACommissionResult' }
                ]
            },
            ibReport: {
                title: '代理报表',
                list: [
                    { text: '已激活代理报表', link: '/ib/ibReport' },
                    { text: '审核跟踪报表', link: '/ib/auditTrailReport' },
                    // { text: '加点设定', link: '/ib/spreadCommissionMappingReport' },
                    { text: '代理佣金设定报表', link: '/ib/allCommissionReport' },
                    // { text: '佣金设定提醒忽略表', link: '/ib/alert-ignore-list' },
                    { text: '佣金设定提醒忽略表', link: '/ib/alert-ignore-list2' },
                    { text: '模板管理', link: '/ib/ibTemplateSetting' },
                ]
            },
            ibReport_v2: {
                title: '代理报表',
                list: [
                    { text: '审核跟踪报表', link: '/ib_v2/auditTrailReport' },
                    // { text: '加点设定', link: '/ib_v2/spreadCommissionMappingReport' },
                    { text: '代理佣金设定报表', link: '/ib_v2/allCommissionReport' },
                    // { text: '佣金设定提醒忽略表', link: '/ib_v2/alert-ignore-list' },
                    { text: '佣金设定提醒忽略表', link: '/ib_v2/alert-ignore-list2' },
                    { text: '模板管理', link: '/ib_v2/ibTemplateSetting' },
                ]
            }
        }
    },
    hk: {
        ibPrimary: {
            back: '返回',
            commissionSetting: '佣金設定',
            templateSetting: '模板管理',
            ibResult: {
                title: '代理結果',
                list: [
                    { text: '實時佣金結果', link: '/ib/realTimeResult' },
                    { text: '月結佣金結果', link: '/ib/monthlyIBResult' },
                    { text: 'CPA佣金結果', link: '/ib/CPACommissionResult' }
                ]
            },
            ibResult_v2: {
                title: '代理結果',
                list: [
                    { text: '實時佣金結果', link: '/ib_v2/realTimeResult' },
                    { text: '月結佣金結果', link: '/ib_v2/monthlyIBResult' },
                    { text: 'CPA佣金結果', link: '/ib_v2/CPACommissionResult' }
                ]
            },
            ibReport: {
                title: '代理報表',
                list: [
                    { text: '已激活代理報表', link: '/ib/ibReport' },
                    { text: '審核跟蹤報表', link: '/ib/auditTrailReport' },
                    // { text: '加點設定', link: '/ib/spreadCommissionMappingReport' },
                    { text: '代理佣金設定報表', link: '/ib/allCommissionReport' },
                    // { text: '佣金設定提醒忽略表', link: '/ib/alert-ignore-list' },
                    { text: '佣金設定提醒忽略表', link: '/ib/alert-ignore-list2' },
                    { text: '模板管理', link: '/ib/ibTemplateSetting' },
                ]
            },
            ibReport_v2: {
                title: '代理報表',
                list: [
                    { text: '審核跟蹤報表', link: '/ib_v2/auditTrailReport' },
                    // { text: '加點設定', link: '/ib_v2/spreadCommissionMappingReport' },
                    { text: '代理佣金設定報表', link: '/ib_v2/allCommissionReport' },
                    // { text: '佣金設定提醒忽略表', link: '/ib_v2/alert-ignore-list' },
                    { text: '佣金設定提醒忽略表', link: '/ib_v2/alert-ignore-list2' },
                    { text: '模板管理', link: '/ib_v2/ibTemplateSetting' },
                ]
            }
        }
    },
    en: {
        ibPrimary: {
            back: 'Back',
            commissionSetting: 'Commission Setting',
            templateSetting: 'Template Maintenance',
            ibResult: {
                title: 'IB Result',
                list: [
                    { text: 'Real Time Result', link: '/ib/realTimeResult' },
                    { text: 'Monthly IB Result', link: '/ib/monthlyIBResult' },
                    { text: 'CPA Result', link: '/ib/CPACommissionResult' }
                ]
            },
            ibResult_v2: {
                title: 'IB Result',
                list: [
                    { text: 'Real Time Result', link: '/ib_v2/realTimeResult' },
                    { text: 'Monthly IB Result', link: '/ib_v2/monthlyIBResult' },
                    { text: 'CPA Result', link: '/ib_v2/CPACommissionResult' }
                ]
            },
            ibReport: {
                title: 'IB Report',
                list: [
                    { text: 'Activated IB Report', link: '/ib/ibReport' },
                    { text: 'Audit Trail Report', link: '/ib/auditTrailReport' },
                    // { text: 'Spread Commission Setting', link: '/ib/spreadCommissionMappingReport' },
                    { text: 'IB Commission Setting Report', link: '/ib/allCommissionReport' },
                    // { text: 'IB Commission Alert Ignores', link: '/ib/alert-ignore-list' },
                    { text: 'IB Commission Alert Ignores', link: '/ib/alert-ignore-list2' },
                    { text: 'Template Maintenance', link: '/ib/ibTemplateSetting' },
                ]
            },
            ibReport_v2: {
                title: 'IB Report',
                list: [
                    { text: 'Audit Trail Report', link: '/ib_v2/auditTrailReport' },
                    // { text: 'Spread Commission Setting', link: '/ib_v2/spreadCommissionMappingReport' },
                    { text: 'IB Commission Setting Report', link: '/ib_v2/allCommissionReport' },
                    // { text: 'IB Commission Alert Ignores', link: '/ib_v2/alert-ignore-list' },
                    { text: 'IB Commission Alert Ignores', link: '/ib_v2/alert-ignore-list2' },
                    { text: 'Template Maintenance', link: '/ib_v2/ibTemplateSetting' },
                ]
            }
        }
    },
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/ibPrimary.js